export enum AiAssistantChatMessageAuthor {
  USER = "USER",
  ASSISTANT = "ASSISTANT",
}

export enum AiAssistantJSONChatMessageType {
  SUBMIT_PAYROLL = "submitPayroll",
  CREATE_EMPLOYEE = "createEmployee",
  INCREASE_HOURLY_RATE = "increaseHourlyRate",
}

export type AiAssistantChatHistoryItem = {
  message: string | AiAssistantSubmissionChatMessage;
  author: AiAssistantChatMessageAuthor;
  timestamp: string;
};

export type AiAssistantChatHistory = AiAssistantChatHistoryItem[];

export type AiAssistantSubmissionChatMessage = {
  type: AiAssistantJSONChatMessageType;
  question: string;
  buttonUrl?: string;
};
